module.exports = __webpack_public_path__ + "static/media/icon-supplies-nailbrush.ac265726.svg";